import React, { useState } from 'react';
import {Button, Form, Modal, Spinner} from "react-bootstrap";
import { isValidEmail } from 'helpers/validator';
import { ElectricityInvoicesService } from '../ElectricityInvoices.service';

interface ElectricityInvoicesReportModalProps {
  handleModalHide: () => void;
}

export function ElectricityInvoicesReportModal(props: ElectricityInvoicesReportModalProps) {
  const [isLoading, setIsLoading] = useState(false);
  const [validated, setValidated] = useState(false)
  const [email, setEmail] = useState("")

  const validate = () => {
    setValidated(true);
    if(!email || !isValidEmail(email)) return false;
    return true;
  }

  const validateSubmit = () => {
    if (validate()) {
        submit();
    }
}

  const submit = async () => {
      setIsLoading(true);

      try {
          await ElectricityInvoicesService.generateInvoicesReport(email);
          
          setTimeout(() => {
              setIsLoading(false);
          }, 100);
      } catch(e) {
          console.error(e)
          setIsLoading(false);
      }
  };

  return (
    <Modal
      show={true}
      onHide={props.handleModalHide}
    >
      <Modal.Header closeButton>
        <Modal.Title>
          Elektriarvete eksport
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
         <Form 
              noValidate 
              validated={validated} 
              onSubmit={(e: any) => e.preventDefault()}
              id={"report-form"}
              className={'d-flex align-items-end'}
          >
            <Form.Group 
                controlId={'form-e-mail'} className='m-0 w-100'
            >
              <Form.Label>
                  E-post
              </Form.Label>
              <Form.Control
                  placeholder="E-post"
                  type="text"
                  value={email}
                  required
                  minLength={1}
                  onChange={(e: any) => setEmail(e.target.value)}
              />
          </Form.Group>
          <Button 
              onClick={validateSubmit}
              type="button"
              variant={"primary"}
              className={"d-flex align-items-center ml-3"}
              disabled={!email || !isValidEmail(email)}
          >
              {
                isLoading ? <Spinner size={"sm"} animation={"border"} /> : <span>Saada</span>
              }
          </Button>
        </Form>
      </Modal.Body>
      <Modal.Footer className="d-flex flex-row align-items-end justify-content-end flex-wrap mb-1">
          <Button 
              variant="info"
              onClick={() => props.handleModalHide()}
              type="button"
              className={"d-flex align-items-center"}
          >
              <span className='px-2'>Tühista</span>
          </Button>
      </Modal.Footer>
    </Modal>    
  );
}
